var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0221 3.15234C9.4363 3.15234 6.52213 6.06651 6.52213 9.65234V12.7832C6.52213 13.444 6.24046 14.4515 5.90463 15.0148L4.65879 17.084C3.88963 18.3623 4.42046 19.7815 5.82879 20.2582C10.498 21.8182 15.5355 21.8182 20.2046 20.2582C21.5155 19.8248 22.0896 18.2757 21.3746 17.084L20.1288 15.0148C19.8038 14.4515 19.5221 13.444 19.5221 12.7832V9.65234C19.5221 6.07734 16.5971 3.15234 13.0221 3.15234Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 3.46656C13.7158 3.09345 12.3276 3.09345 11.0176 3.46656C11.3317 2.6649 12.1117 2.10156 13.0217 2.10156C13.9317 2.10156 14.7117 2.6649 15.0259 3.46656V3.46656Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2715 20.6484C16.2715 22.4359 14.809 23.8984 13.0215 23.8984C12.1332 23.8984 11.3098 23.5301 10.7248 22.9451C10.1162 22.3355 9.77343 21.5099 9.77148 20.6484",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.430a05c5b831aa7fc01e0e7722f7a629.svg";
export { ForwardRef as ReactComponent };